/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Folder_HelpInputs */

const en_audio_description_export_folder_help = /** @type {(inputs: Audio_Description_Export_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select where to save your audio description files`)
};

const fr_audio_description_export_folder_help = /** @type {(inputs: Audio_Description_Export_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez l'emplacement pour enregistrer vos fichiers de description audio`)
};

const de_audio_description_export_folder_help = /** @type {(inputs: Audio_Description_Export_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie aus, wo Ihre Audiobeschreibungsdateien gespeichert werden sollen.`)
};

const it_audio_description_export_folder_help = /** @type {(inputs: Audio_Description_Export_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona dove salvare i file delle descrizioni audio`)
};

const ru_audio_description_export_folder_help = /** @type {(inputs: Audio_Description_Export_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите место для сохранения файлов аудиоописания.`)
};

const es_audio_description_export_folder_help = /** @type {(inputs: Audio_Description_Export_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione dónde guardar sus archivos de descripción de audio`)
};

const zh_cn2_audio_description_export_folder_help = /** @type {(inputs: Audio_Description_Export_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择音频描述文件的保存位置`)
};

const ja_audio_description_export_folder_help = /** @type {(inputs: Audio_Description_Export_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音声説明ファイルを保存する場所を選択してください`)
};

const hi_audio_description_export_folder_help = /** @type {(inputs: Audio_Description_Export_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो विवरण फ़ाइलों को सहेजने के लिए स्थान चुनें`)
};

const pt_pt2_audio_description_export_folder_help = /** @type {(inputs: Audio_Description_Export_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione onde salvar seus arquivos de audiodescrição.`)
};

/**
* | output |
* | --- |
* | "Select where to save your audio description files" |
*
* @param {Audio_Description_Export_Folder_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_folder_help = /** @type {((inputs?: Audio_Description_Export_Folder_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Folder_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_folder_help(inputs)
	if (locale === "de") return de_audio_description_export_folder_help(inputs)
	if (locale === "it") return it_audio_description_export_folder_help(inputs)
	if (locale === "ru") return ru_audio_description_export_folder_help(inputs)
	if (locale === "es") return es_audio_description_export_folder_help(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_folder_help(inputs)
	if (locale === "ja") return ja_audio_description_export_folder_help(inputs)
	if (locale === "hi") return hi_audio_description_export_folder_help(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_folder_help(inputs)
	return en_audio_description_export_folder_help(inputs)
});